import React from 'react'
import '../Assets/Styles.css'

function Works() {
    return (
        <div style={{marign:0}}>
            <h1 className="Header">Works</h1>
        </div>
    )
}

export default Works
